import axios from "axios";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

export const fetchPatientApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.patientBase,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const getPatientByIdApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.patientFetchById,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const fetchOrderCountApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.fetchOrderCount,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const createPatientApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.patientBase,
    method: "POST",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const updatePatientApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.patientBase,
    method: "PATCH",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const updateOrderApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.updateOrder,
    method: "PATCH",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};